import label from "fragments/vendors/label"
import { gql } from "graphql-tag"

const GET_LABEL_BY_ID = gql`
  ${label}

  query getLabelById($id: ID!) {
    getLabelById(id: $id) {
      ...Label
    }
  }
`

export default GET_LABEL_BY_ID
